import { StdResponse, request } from "@/global/config/request";
import { GlobalDataBox } from "@/global/interface/lib-device/global-data-box";


export function getGlobalDataBoxDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalDataBox(data: GlobalDataBox, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalDataBox(id: number, data: GlobalDataBox, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-data-boxes/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalDataBox(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalDataBoxes(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-data-boxes`, {
        params: {
            ...params,
        }
    })
}